<template>
  <div class="home">
    <Login @closeLogin="closeLogin" v-if="teacherLogin" />
    <small-card-list :inputSelectedCard="selectedCard" @closeCardList="closeCardList" v-if="CardListOpen"/>
    <div class="bg cover">
      <div class="container" style="height : 100%">
        <div class="row align-items-center" style="height : 100%">
          <div class="col-2"></div>
          <div class="col ml-5 title">
            <h1>AR互動學英文
              <br>活潑又有趣
            </h1>
            <br>
            <p>透過平板與手機,認識全世界</p>
          </div>
        </div>
      </div>
    </div>
    <!-- characteristic -->
    <div id="characteristic" class="container main">
      <div class="row">
        <div class="col-md-6">
          <img class="my-4 img" src="../assets/images/pic_feature_01.jpg" alt="">
          <img class="my-4 img" src="../assets/images/pic_feature_03.jpg" alt="">
        </div>
        <div class="col-md-6">
          <img class="my-4 img" src="../assets/images/pic_feature_02.jpg" alt="">
          <img class="my-4 img" src="../assets/images/pic_feature_04.jpg" alt="">
        </div>
      </div>
      <!-- topic content -->
      <h2 id="content" class="sub_title mt-2">主題內容</h2>
      <div class="home-Carousel">
        <Carousel class="carousel my-4" :autoplay="false" :paginationEnabled="false" :perPage="1" :centerMode="true"
          :navigationEnabled="true" :navigationNextLabel="''" :navigationPrevLabel="''" :navigationClickTargetSize="0">
          <Slide v-for="(silde, index) in cardList.length" :key="index" class="row mx-auto">
            <div v-for="card in cardList[index]" :key="card.cardID" class="card col-3 p-2" @click="goCardList(card)">
              <img :src="card.ImageUrl.src" class="card-img-top" alt="...">
              <div class="card-body">
                <p class="card-text">{{card.topic}}</p>
                <p style="color: #f46d7c; font-size:.8rem">{{card.topic_en}}</p>
              </div>
            </div>
          </Slide>
        </Carousel>
      </div>
      <!-- video -->
        <video width="100%" controls>
          <source src="../assets/media/Live Culture 宣傳影片.mp4" type="video/mp4">
        </video>
      <!-- app download -->
      <div id="app_download" class="row">
        <div class="col-12">
          <div class="container app_box my-4">
            <h3>軟體下載</h3>
            <div class="row justify-content-center my-4">
                <div class="col-6">
                  <p>本產品能夠在任何平板與手機上使用，請依照你所持的設備，選擇對硬軟體的下載管道。現在就立刻加入我們，一起用AR環遊世界學英語。</p>
                </div>
            </div>
            <div class="row app_layout justify-content-center">
              <div class="col-md-2 align-self-center">
                <img src="../assets/images/pic_app_icon_red.png" alt="pic_app_icon_red.png">
              </div>
              <div class="col-md-3">
                <a  target="_blank" href="https://apps.apple.com/us/app/live-culture/id1383620511">
                  <img class="py-1" src="../assets/images/pic_apple_store.png" alt="pic_apple_store.png">
                </a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.liveabc.arcampus&hl=zh-TW">
                  <img class="py-1" src="../assets/images/pic_google_store.png" alt="pic_google_store.png">
                </a>
              </div>
              <!-- <div class="col-md-2 align-self-center m-md-0  mt-4">
                <img src="../assets/images/pic_app_icon_blue.png" alt="">
              </div>
              <div class="col-md-3">
                <img class="py-1" src="../assets/images/pic_apple_store.png" alt="">
                <img class="py-1" src="../assets/images/pic_google_store.png" alt="">
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- teacher login -->
    <!-- <div id="teacher_login" class="bg cover_teacher">
      <div class="container" style="height : 100%">
        <div class="row align-items-center" style="height : 100%">
          <div class="col-md-6"></div>
          <div class="col-md-6 teacher_login">
            <h2 class="sub_title">教師登入</h2>
            <br>
            <p style="width: 80%; margin:20px auto">如果您是與我們企業合作的教師，請您使用下方的按鈕進行登入，前往並開啟較用版本的內容。若是您希望與我們合作，請聯絡我們:0800-000123</p>
            <button type="button" class="btn-pink btn" @click="goLogin" >點我登入</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import SmallCardList from '@/components/SmallCardList.vue'
import { Carousel, Slide } from 'vue-carousel'
export default {
  name: 'home',
  components: {
    Login,
    SmallCardList,
    Carousel,
    Slide
  },
  data () {
    return {
      teacherLogin: false,
      CardListOpen: false,
      selectedCard: '',
      cardList: [
        [{
          cardID: '1',
          topic: '環遊世界 - 美國',
          topic_en: 'United States',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_usa_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_01.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_02.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_03.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_04.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_05.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_06.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_07.jpg') },
            { src: require('../assets/images/pic_activity_card/usa/pic_usa_08.jpg') }
          ]
        },
        {
          cardID: '2',
          topic: '環遊世界 - 澳洲',
          topic_en: 'Australia',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_australia_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_01.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_02.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_03.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_04.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_05.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_06.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_07.jpg') },
            { src: require('../assets/images/pic_activity_card/australia/pic_australia_08.jpg') }
          ]
        },
        {
          cardID: '3',
          topic: '環遊世界 - 印度',
          topic_en: 'India',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_india_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/india/pic_india_01.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_02.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_03.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_04.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_05.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_06.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_07.jpg') },
            { src: require('../assets/images/pic_activity_card/india/pic_india_08.jpg') }
          ]
        },
        {
          cardID: '4',
          topic: '環遊世界 - 俄羅斯',
          topic_en: 'Russia',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_russia_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_01.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_02.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_03.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_04.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_05.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_06.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_07.jpg') },
            { src: require('../assets/images/pic_activity_card/russia/pic_russia_08.jpg') }
          ]
        },
        {
          cardID: '5',
          topic: '環遊世界 - 法國',
          topic_en: 'France',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_france_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/france/pic_france_01.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_02.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_03.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_04.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_05.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_06.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_07.jpg') },
            { src: require('../assets/images/pic_activity_card/france/pic_france_08.jpg') }
          ]
        },
        {
          cardID: '6',
          topic: '環遊世界 - 日本',
          topic_en: 'Japan',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_japan_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_01.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_02.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_03.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_04.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_05.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_06.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_07.jpg') },
            { src: require('../assets/images/pic_activity_card/japan/pic_japan_08.jpg') }
          ]
        },
        {
          cardID: '7',
          topic: '環遊世界 - 英國',
          topic_en: 'United Kingdom',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_uk_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_01.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_02.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_03.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_04.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_05.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_06.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_07.jpg') },
            { src: require('../assets/images/pic_activity_card/uk/pic_uk_08.jpg') }
          ]
        },
        {
          cardID: '8',
          topic: '環遊世界 - 德國',
          topic_en: 'Germany',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_germany_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_01.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_02.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_03.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_04.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_05.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_06.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_07.jpg') },
            { src: require('../assets/images/pic_activity_card/germany/pic_germany_08.jpg') }
          ]
        }],
        [{
          cardID: '9',
          topic: '環遊世界 - 埃及',
          topic_en: 'Egypt',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_egypt_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_01.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_02.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_03.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_04.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_05.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_06.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_07.jpg') },
            { src: require('../assets/images/pic_activity_card/egypt/pic_egypt_08.jpg') }
          ]
        },
        {
          cardID: '10',
          topic: '環遊世界 - 巴西',
          topic_en: 'Brazil',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_map_brazil_S.jpg')
          },
          type: 'country',
          hasCard: true,
          cardList: [
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_01.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_02.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_03.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_04.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_05.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_06.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_07.jpg') },
            { src: require('../assets/images/pic_activity_card/brazil/pic_brazil_08.jpg') }
          ]
        },
        {
          cardID: '11',
          topic: '海洋世界',
          topic_en: 'Ocean',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_ocean_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        },
        {
          cardID: '12',
          topic: '我們的城市',
          topic_en: 'Our city',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_our_city_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        },
        {
          cardID: '13',
          topic: '我的家庭',
          topic_en: 'My family',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_family_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        },
        {
          cardID: '14',
          topic: '動物園',
          topic_en: 'Zoo',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_zoo_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        },
        {
          cardID: '15',
          topic: '我的學校',
          topic_en: 'My school',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_school_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        },
        {
          cardID: '16',
          topic: '速食餐廳',
          topic_en: 'Fast food',
          ImageUrl: {
            src: require('../assets/images/pic_world/pic_fast_food_S.jpg')
          },
          type: 'live',
          hasCard: false,
          cardList: []
        }]
      ]
    }
  },
  methods: {
    goLogin () {
      this.teacherLogin = !this.teacherLogin
    },
    closeLogin (item) {
      this.teacherLogin = item
    },
    goCardList (card) {
      this.selectedCard = card.cardList
      card.hasCard ? this.CardListOpen = !this.CardListOpen : alert('coming soon')
    },
    closeCardList (item) {
      this.CardListOpen = item
    }
  }
}
</script>

<style lang="scss" scoped>
  .home{
    background-color: #f2f2f2;
  }
  .bg {
    height: 80vh;
    background-position: center;
    text-align: left;
    .title {
      color: #1351a4;
      font-weight: bolder;
      border-left: #f46d7c solid 5px;
      font-weight: 900;
    }
  }
  .main img {
    width: 100%;
  }
  .sub_title {
    color: #4d4d4d;
    font-size: 1.5rem;
    font-weight: 900;
    margin: 0;
  }
  .cover {
    background: url('../assets/images/pic_bg_01.jpg') no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -webkit-background-size: cover;
  }
  .cover_teacher {
    background: url('../assets/images/pic_bg_02.jpg') no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -webkit-background-size: cover;
  }
  .card {
    cursor: pointer;
    margin: 10px 0px;
    .card-body{
      height: 80px;
      padding: 5px !important;
    }
    p {
      text-align-last: left;
      margin: 0;
    }
  }
  .app_box {
    padding: 60px 0;
    background-color: #a1b2fa;
    color: #fff;
  }
  .app_layout {
    width: 90%;
    margin: auto
  }
  .teacher_login {
    text-align: center;
    p {
      color:#808080;
    }
  }
  @media screen and (min-width: 600px){
    .main {
      width: 70%;
    }
  }
</style>
<style lang="scss" >
  @media screen and (min-width: 600px){
    .home-Carousel{
      .VueCarousel-navigation-prev::before{
        content: '';
        position: absolute;
        background: url('../assets/images/btn_arrow_L_blue.png') no-repeat top left /30px 30px;
        z-index: 2;
        right: 20px;
        top: -25px;
        width: 30px;
        height: 30px;
      }
      .VueCarousel-navigation-next::before{
        content: '';
        position: absolute;
        background: url('../assets/images/btn_arrow_R_blue.png') no-repeat top left /30px 30px;
        z-index: 2;
        top: -25px;
        left: 20px;
        width: 30px;
        height: 30px;
      }
    }
  }
</style>
